<ca-conversation-standart-video-call-list
  *ngIf="standardListVisible"
  (conversationIdChange)="onConversationIdChanged($event)"
  (dataLoaded)="onDataLoaded()"
  [compactPlayer]="compactPlayer"></ca-conversation-standart-video-call-list>
